import styled from 'styled-components';

export const ExportIconWrapper = styled.span`
  font-size: 18px;
`;

export const ContentWrapper = styled.p`
  padding: 16px 16px 0px 16px;
`;
